import { render, staticRenderFns } from "./AppuntamentiComponent.vue?vue&type=template&id=0186f55f"
import script from "./AppuntamentiComponent.vue?vue&type=script&lang=js"
export * from "./AppuntamentiComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports